/**
 * Context target used for storage location API calls within warehouse spaces.
 * Currently mapped to 'TIRE-WAREHOUSE' — update when backend exposes a dedicated warehouse-space target.
 */
export const STORAGE_LOCATION_CONTEXT_TARGET = 'WAREHOUSE-SPACE' as const;
